exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\na[data-v-82e49726] {\n  text-decoration: underline;\n}\n", ""]);

// exports
